<template>
	<div class="nav" :style="{background:bgColor}">
		<div class="back_img" @click="back" ><img src="@/images/back_arrow.png" /></div>
		<h1 class="nav_title" :style="{color:color}">{{title}}</h1>

	</div>
</template>

<script>
	export default {
		props:{
			img:{
				type:String,
				default:"../src/images/"
			},
			title:{
				type:String,
				default:"这是标题"
			},
			url:{
				type:String,
				default:"/",
			},
			goType:{
				type:String,
				default:"2"
			},
			color:{
				type:String,
				default:"#000000"
			},
			bgColor:{
				type:String,
				default:"#ffffff"
			}
		},
		data() {
			return{
				
			}
		},
		methods:{
			back(){
				if(this.goType==1){
					console.log("跳转")
					this.$router.push({path:this.url})
				}else{
					console.log("回退")
					this.$router.go(-1);
				}
				
			}
		}
	}
</script>

<style scoped="scoped">
	.nav {
		
		position: fixed;
		width: 100%;
		height: 50px;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #fff;
		z-index: 9998;
		
	}

	.nav_title {
		font-size: 18px;
		font-weight: 400;
		color: rgba(34, 34, 34, 1);
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
	}

	.back_img {
		position: absolute;
		top: 50%;
		left: 15px;
		transform: translateY(-50%);
		width: 10px;
		height: 18px;
	}
</style>
